import React from "react";

const ReassignUsersIcon = ({ size = 32, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...rest}
  >
    <g stroke="#043766">
      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
      <path d="M16 3.128a4 4 0 0 1 0 7.744" />
      <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
      <circle cx="9" cy="7" r="4" />
    </g>
    <circle cx="24" cy="24" r="7" fill="#fff" />
    <g transform="translate(17 17) scale(0.58)" stroke="#0269d7" strokeWidth="3">
      <path d="M21 7v5h-5" />
      <path d="M21 12a9 9 0 1 0-2.64 6.36" />
    </g>
  </svg>
);

export default ReassignUsersIcon;
